import { render, staticRenderFns } from "./InvoiceGroup.vue?vue&type=template&id=2963a3e6&scoped=true"
import script from "./InvoiceGroup.vue?vue&type=script&lang=js"
export * from "./InvoiceGroup.vue?vue&type=script&lang=js"
import style0 from "./InvoiceGroup.vue?vue&type=style&index=0&id=2963a3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2963a3e6",
  null
  
)

export default component.exports